module.exports = __webpack_public_path__ + "img/NZA Annex A2 - Technical appendix to EER report.pdf";